// extracted by mini-css-extract-plugin
export default {"tableContainer":"style_tableContainer__N0tap","customTable":"style_customTable__6hpwv","profileButton":"style_profileButton__tZzcX"};